import { isTesting } from 'utils/env';

const getOrThrow = (varName: string) => {
  const value = process.env[varName];

  const hasNoValue = !value || !value.length;
  if (!isTesting && hasNoValue) {
    throw new Error(`Missing ${varName} set in environment variables`);
  }

  return value as string;
};

export const ENV_VARS = {
  DATA_URL: getOrThrow('REACT_APP_DATA_URL'),
  IDENTITY_URL: getOrThrow('REACT_APP_IDENTITY_URL'),
  INTEGRATIONS_URL: getOrThrow('REACT_APP_INTEGRATIONS_URL'),
  LEVVRSERVICE_URL: getOrThrow('REACT_APP_LEVVRSERVICE_URL'),
  META_URL: getOrThrow('REACT_APP_META_URL'),
  NOTIFICATION_SIGNALR_URL: getOrThrow('REACT_APP_NOTIFICATION_SIGNALR_URL'),
  PERSONALSETTINGS_URL: getOrThrow('REACT_APP_PERSONALSETTINGS_URL'),
  SIGNALR_URL: getOrThrow('REACT_APP_SIGNALR_URL'),
  SUBSCRIPTIONS_URL: getOrThrow('REACT_APP_SUBSCRIPTIONS_URL'),

  CLIENT_ID: getOrThrow('REACT_APP_CLIENT_ID'),
  REDIRECT_URL: getOrThrow('REACT_APP_REDIRECT_URL'),

  INSTRUMENTATION_KEY: getOrThrow('REACT_APP_INSTRUMENTATION_KEY'),
  MUI_LICENCE_KEY: getOrThrow('REACT_APP_MUI_LICENCE_KEY'),
  // DO NOT throw this. DevOps could simply just remove this from the environment variables.
  MAINTENANCE_MODE_ENABLED: process.env.REACT_APP_MAINTENANCE_MODE_ENABLED === 'true',
  MAINTENANCE_MODE_URL: getOrThrow('REACT_APP_MAINTENANCE_MODE_URL')
} as const;
